"use client";

import { useState } from "react";
import {
  Command,
  // CommandEmpty,
  // CommandGroup,
  CommandInput,
  // CommandItem,
  // CommandList,
} from "../../components/ui/command";
import { useTranslation } from "react-i18next";
import { indexStore } from "../../store/indexStore";
import { IMG_URl } from "../../common/img_url";
import Visibility from "../utils/Visibility";
// import { useNavigate } from "react-router-dom";
import ProductModel from "../../Models/PorductModel";
import { useParams } from "react-router-dom";

function SearchField() {
  const { name, fetchSearchProducts, searchProducts } = indexStore();
  const [query, setQuery] = useState("");

  const params = useParams();
  const showDropdown = query.length > 0;
  const { t } = useTranslation();
  const loading = false;
  const handleClick = (item: ProductModel) => {
    window.location.replace(
      `/${params.domain}/${params.branch_id}/${item.menu_id}/${item.id}`
    );
    setQuery("");
  };
  const handleChange = (search: string) => {
    setQuery(search);
    if (search !== "") {
      const SearchParams = {
        word: search,
        branch_id: params.branch_id,
        domain: params.domain,
      };
      fetchSearchProducts(SearchParams);
    }
  };

  return (
    <div className="w-full  mx-auto  relative">
      <Command className="rounded- border rounded-full shadow-md">
        <CommandInput
          className="w-full rounded-full outline-none"
          placeholder={t("gloabl.search")}
          value={query}
          onValueChange={handleChange}
        />
        <Visibility visible={showDropdown}>
          <div className="absolute top-10 rounded-b-2xl z-50 mt-1 w-full bg-background border shadow-lg rounded-md max-h-64 overflow-auto">
            {loading && <div className="p-2">{t("gloabl.loading")}</div>}

            {!loading && searchProducts.length === 0 && (
              <div className="p-2 text-sm text-gray-500">
                {t("gloabl.noResult")}
              </div>
            )}

            {!loading &&
              searchProducts.length > 0 &&
              searchProducts.map((product) => (
                <div
                  key={product.id}
                  className="flex items-center gap-3 p-2 hover:bg-accent cursor-pointer"
                  onClick={() => handleClick(product)}
                >
                  <img
                    src={`${IMG_URl}/${product.image}`}
                    alt={product.name_en}
                    className="w-10 h-10 object-cover rounded-md"
                  />
                  <span>
                    {String(product[name as keyof ProductModel] || "")}
                  </span>
                </div>
              ))}
          </div>
        </Visibility>
      </Command>
    </div>
  );
}

export default SearchField;
